import { component } from 'picoapp'

export default component((node) => {
  const enableTouched = () => (node.dataset.touched = 'true')
  const disableTouched = () => (node.dataset.touched = 'false')
  node.addEventListener('touchstart', enableTouched)
  node.addEventListener('touchend', disableTouched)

  return () => {
    node.removeEventListener('touchstart', enableTouched)
    node.removeEventListener('touchend', disableTouched)
  }
})
